import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import Stepper from '../../../../common/stepper/Stepper';
import StepFooter from '../../../../common/stepper/StepFooter';
import TenancyBasicForm from './TenancyBasicForm';
import TenancyDocumentForm from './TenancyDocumentForm';
import Breadcrumbs from '../../../../common/BreadCrum/BreadCrum';
import SectionHeaderBar from '../../../../common/pageheading/SectionHeaderBar';

const TenantTenancyStepper = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { tenantUserId, siteId, userData } = location.state || {};

    const [currentStep, setCurrentStep] = useState(1);
    const [tenancyId, setTenancyId] = useState(null);
    const [loading, setLoading] = useState(false);

    const step1Ref = React.useRef();
    const step2Ref = React.useRef();

    // If accessed directly without state, bounce back
    useEffect(() => {
        if (!tenantUserId) {
            navigate('/zentres/user-management');
        }
    }, [tenantUserId, navigate]);

    const steps = [
        { id: 1, label: "Tenancy Details" },
        { id: 2, label: "Document Upload" }
    ];

    const handleNext = async () => {
        if (currentStep === 1 && step1Ref.current) {
            const success = await step1Ref.current.submit();
            // child will call handleNextStep(tenancyId) if success
        } else if (currentStep === 2 && step2Ref.current) {
            const success = await step2Ref.current.submit();
            // child will call handleComplete() if success
        }
    };

    const handleNextStep = (newTenancyId) => {
        if (newTenancyId) {
            setTenancyId(newTenancyId);
        }
        setCurrentStep(2);
    };

    const handlePrevStep = () => {
        setCurrentStep(1);
    };

    const handleComplete = () => {
        navigate('/zentres/user-management');
    };

    const handleCancel = () => {
        navigate('/zentres/user-management');
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto gap-4">
            <div className="mb-2">
                <Breadcrumbs />
            </div>

            {/* Stepper Component (Floating at Top) */}
            <div className="flex justify-center mb-6 mt-2">
                <Stepper steps={steps} currentStep={currentStep} />
            </div>

            {/* Page Heading using SectionHeaderBar */}
            <div className="mb-4">
                <SectionHeaderBar
                    heading="Manage Tenant Tenancy"
                    subHeading="Configure and upload tenancy documents for this user."
                />
            </div>

            {/* Stepper Content Area (No borders/backgrounds here, children have their own cards) */}
            <div className="flex-1">
                {currentStep === 1 && (
                    <TenancyBasicForm
                        ref={step1Ref}
                        siteId={siteId}
                        tenantUserId={tenantUserId}
                        userData={location.state?.userData || {}}
                        tenancyData={location.state?.tenancyData || null}
                        onNext={handleNextStep}
                        setGlobalLoading={setLoading}
                    />
                )}
                {currentStep === 2 && (
                    <TenancyDocumentForm
                        ref={step2Ref}
                        tenancyId={tenancyId}
                        tenancyData={location.state?.tenancyData || null}
                        onComplete={handleComplete}
                        setGlobalLoading={setLoading}
                    />
                )}
            </div>

            <div className="mt-6">
                <StepFooter
                    step={currentStep}
                    totalSteps={steps.length}
                    onNext={handleNext}
                    onPrev={currentStep === 2 ? handlePrevStep : handleCancel}
                    disableNext={loading}
                    isLoading={loading}
                    nextBtnText={currentStep === 2 ? "Complete Setup" : "Save & Continue"}
                />
            </div>
        </div>
    );
};

export default TenantTenancyStepper;

